module.exports = __webpack_public_path__ + "img/hr-level2addon_mining_hands.ece07984.png";